var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.931 5.164a1.192 1.192 0 012.138 0l5.197 10.527a4.777 4.777 0 003.59 2.61l11.623 1.701a1.192 1.192 0 01.661 2.034l-8.406 8.186a4.777 4.777 0 00-1.375 4.225l1.985 11.565a1.192 1.192 0 01-1.735 1.26L29.22 41.81a4.774 4.774 0 00-4.44 0l-10.388 5.463a1.192 1.192 0 01-1.732-1.26L14.64 34.45a4.775 4.775 0 00-1.375-4.227L4.86 22.038A1.192 1.192 0 015.522 20l11.62-1.699a4.776 4.776 0 003.594-2.61l5.195-10.527z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/Star-full.1ecfdc86.svg";
export { SvgStarFull as ReactComponent };